import React from 'react';
import { Advertisement } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/views/ad.less';

export default Advertisement;
